import store from '../store';
import Index from '../views/boughts/Index.vue';
import FattureincloudOrder from '../views/fattureincloud/Order.vue';
import { checkauth } from '../Helper';

// inserimento e dettaglio sono pagine: tornando indietro la lista riparte dal suo URL
const BoughtCreate = () => import('../views/boughts/Create.vue');
const BoughtDetail = () => import('../views/boughts/Detail.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/bought',
		name: 'bought-list',
		component: Index,
		beforeEnter: auth,
	},
	{
		path: '/bought/new',
		name: 'bought-new',
		component: BoughtCreate,
		beforeEnter: auth,
	},
	{
		path: '/bought/:id',
		name: 'bought-detail',
		component: BoughtDetail,
		beforeEnter: auth,
	},
	/*{
		path: '/fattureincloudorder',
		name: 'fattureincloudorder',
		component: FattureincloudOrder,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},*/
];
